
            const data = {"name":"angle-up","data":{"viewBox":"0 0 512 512","data":"<path pid=\"0\" d=\"M399 338c0 3-1 5-3 7l-15 14c-1 2-4 3-6 3-3 0-5-1-7-3L256 247 144 359c-2 2-4 3-7 3-2 0-5-1-6-3l-15-14c-2-2-3-4-3-7 0-2 1-4 3-6l133-133c2-2 5-3 7-3s5 1 7 3l133 133c2 2 3 4 3 6z\"/>","originalColors":[],"stopColors":[]}}
        
                    module.exports = data
                    